import React from 'react';
import './WelcomeHome.css';
import { JEAN_PIAGET_LOGO_DATA_URI } from '../assets/brandAssets';

export function WelcomeHome() {
  return (
    <div className="welcome-page">
      <img
        src={JEAN_PIAGET_LOGO_DATA_URI}
        alt="Instituto Jean Piaget"
        className="welcome-page__logo"
      />
      <h1 className="welcome-page__title">
        Bienvenido al Sistema de Gestión Académica del Instituto Terciario Jean Piaget
      </h1>
    </div>
  );
}
